import api from "./api"

export default {
    async post(payload: { items: any[] }) {
        return api.request('/api/faqs', 'POST', payload)
    },
    async all() {
        return api.request('/api/faqs', 'GET')
    },
}   